import React, {useContext} from 'react';
import Divider from "@mui/material/Divider/Divider";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import { MenuItem } from "../../models/menu/Menu";
import {ListItemButton, ListItemIcon, Tooltip} from "@mui/material";
import {NavDrawerItemIcon} from "./NavDrawerItemIcon";
import {VisibilityHandler} from "../common/VisibilityHandler";
import {getWeekRange} from "../../helpers/DateTimeHelpers";
import {NavigationLink} from "./NavLink";
import {LanguageContext} from "../../config/ContextConfig";

/**
 * typescript
 */
interface NavDrawerItemProps {
    viewLink: MenuItem
    active?: boolean
    hideText?: boolean
    onCLick: ( identifier: string, to: string ) => void
    unsavedDataProtection?: boolean
}

function NavDrawerItem({ viewLink, active, onCLick, hideText, unsavedDataProtection }: NavDrawerItemProps) {


    const language = useContext(LanguageContext);
    const linkIdentifier = viewLink.linkTitle.rawValue;
    const isActive = active;

    let activeStyle = isActive
        ? "menu-border-active"
        : "menu-border"

    const colorScheme = isActive ? 'icon-active' : 'icon';

    if( hideText ) {
        activeStyle += " menu-border-hidden";
    }


    if( viewLink.routes ) {

        const link = viewLink.routes.main.path;

        //@ts-ignore
        const displayTitle = language.mainMenu[ viewLink.viewIdentifier ]?.title ?? language[ viewLink.viewIdentifier ].title;


        return (
            <div key={'nav-drawer-' + linkIdentifier} className={'nav-list-item nav-drawer-background '+ activeStyle}>
                <NavigationLink
                    to={ link }
                    unsavedDataProtection={ unsavedDataProtection }
                    onClick={() => onCLick( linkIdentifier, link )}
                >
                    <Tooltip title={ displayTitle }  placement={'right-end'}>
                        <ListItemButton style={{ display: "flex", height: '60px' }}>
                            <ListItemIcon>
                                <NavDrawerItemIcon
                                    itemIdentifier={ viewLink.viewIdentifier }
                                    itemLink={ link }
                                    className={ colorScheme }
                                />
                            </ListItemIcon>
                            <VisibilityHandler isVisible={ ! hideText ?? true }>
                                <ListItemText
                                    className={colorScheme}
                                    primary={ displayTitle }
                                />
                            </VisibilityHandler>

                        </ListItemButton>
                    </Tooltip>

                </NavigationLink>
                <Divider/>
            </div>
        );
    } else {
        const currentDateRange = getWeekRange( new Date() );
        const link = ( linkIdentifier ===  "calendar" )
            ? `/${linkIdentifier}/week/${ currentDateRange.start.getTime() }/#grid-times-07:00:00`
            : "/"+linkIdentifier;


        //@ts-ignore
        const displayTitle = language.mainMenu[ linkIdentifier ]?.title ?? language[ linkIdentifier ].title;

        return (
            <div key={'nav-drawer-' + linkIdentifier} className={'nav-drawer-background '+ activeStyle}>
                <NavigationLink
                    to={ link }
                    unsavedDataProtection={ unsavedDataProtection }
                    onClick={() => onCLick( linkIdentifier, link )}
                >
                    <Tooltip title={ displayTitle }  placement={'right-end'}>
                        <ListItemButton  style={{ display: "flex", height: '60px' }}>
                            <ListItemIcon>
                                <NavDrawerItemIcon
                                    itemIdentifier={ viewLink.viewIdentifier }
                                    itemLink={link }
                                    className={colorScheme}
                                />
                            </ListItemIcon>
                            <VisibilityHandler isVisible={ ! hideText ?? true }>
                                <ListItemText
                                    className={colorScheme}
                                    primary={ displayTitle }
                                />
                            </VisibilityHandler>
                        </ListItemButton>
                    </Tooltip>

                </NavigationLink>
                <Divider/>
            </div>
        );
    }
}

export default NavDrawerItem;